import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class QuotationService {

    appUrl = "";
    localAppUrl = "";
    coreUrl = ""
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: HttpClient) {
        this.appUrl = environment.apiUrl + "Cases/";
        this.coreUrl = environment.coreUrl;
        this.localAppUrl = environment.localApiUrl;
    }

    getLoggedUser(userId) {
        return this.http.get<any>(this.localAppUrl + 'users/' + userId)
            .toPromise()
            .then(res => res);
    }

    updateUser(user) {
        return this.http.put(this.localAppUrl + 'users/' + user.id, user, { headers: this.headers })
            .toPromise()
            .then(() => user);
    }

    getAllCases() {
        return this.http.get<any>(this.localAppUrl + 'allCases')
            .toPromise()
            .then(res => res);
    }

    addCase(c) {
        return this.http.post<any>(this.localAppUrl + 'allCases/', c)
            .toPromise()
            .then(res => res);
    }

    getCaseById(caseId) {
        let url = this.localAppUrl + 'allCases/' + caseId;
        return this.http.get<any>(url).toPromise().then(res => res);;
    }

    updateCase(oneCase) {
        return this.http.put(this.localAppUrl + 'allCases/' + oneCase.id, oneCase, { headers: this.headers })
            .toPromise()
            .then(() => oneCase);
    }

    deleteCase(id) {
        return this.http.delete<any>(this.localAppUrl + 'allCases/' + id)
            .toPromise()
            .then(res => res);
    }

    checkClearBitData(email) {
        return this.http.get<any>(environment.clearBitAPIURL + email, {
            headers: new HttpHeaders({
                "Authorization": environment.clearBitAPIKey
            })
        })
            .toPromise()
            .then(res => res)
    }

    getAllStages() {
        return this.http.get<any>(this.localAppUrl + 'CaseStages')
            .toPromise()
            .then(res => res);
    }

    updateCaseStage(caseStage) {
        let url = this.localAppUrl + "CaseStages?id=" + caseStage.id + "&caseStageId=" + caseStage.caseStageId
        return this.http.put<any>(url, {
            headers: this.headers
        })
            .toPromise()
            .then(res => res);
    }

    getAllContactSource(companyID: number) {
        return this.http.get<any>(this.coreUrl + 'Source/' + "?organizationId=" + companyID )
            .toPromise()
            .then(res => res);
    }

    getAllCategory() {
        return this.http.get<any>(this.localAppUrl + 'Category')
            .toPromise()
            .then(res => res);
    }

    getAllSubCategory() {
        return this.http.get<any>(this.localAppUrl + 'SubCategory')
            .toPromise()
            .then(res => res);
    }

    getAllPirority() {
        return this.http.get<any>(this.localAppUrl + 'Priority')
            .toPromise()
            .then(res => res);
    }

}